import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// CSS
import './../../../css/search-form.css';

class SearchForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			q: '',
		};
	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSubmit();
		}
	}

	handleInputChange(event) {
		const { value } = event.target;
		this.setState({
			q: value,
		});
	}

	handleSubmit() {
		this.props.history.push('/search-results?q=' + this.state.q);
		this.setState({
			q: '',
		});
	}

	render() {
		return (
			<div className="search_form icon-search">
				<input
					type="text"
					placeholder="SEARCH..."
					value={this.state.q}
					onKeyPress={(e) => this.handleKeyPress(e)}
					onChange={(e) => this.handleInputChange(e)}
				/>
			</div>
		);
	}
}

export default withRouter(SearchForm);



// WEBPACK FOOTER //
// ./src/components/header/LogoSection/SearchForm.js